import {createContext, useContext} from "react";



export interface IConfig {
    server: string;
    contentServer:string;
}
export const ConfigContext = createContext<IConfig|null>(null);


export function useConfig() {
    const retval = useContext(ConfigContext);
    if (retval === null) {
        throw new Error('config has not been initialized properly!');
    }
    return retval;
}